import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import BaseSlotWinningsController from 'Engine/base/winings/BaseSlotWinningsController';
import { gsap } from 'gsap';
import './style.css';
import eEventTypes from './enums/eEventTypes';
import eStateTypes from './enums/eStateTypes';
import eBaseEventTypes from 'Engine/enums/eBaseEventTypes';

export default class Main extends FlashLib.MovieClip {
  constructor(data, displayItemData) {
    super(data, displayItemData);

    this.reelsContainer = null;

    this.addListeners();
  }

  onGameResized(data) {
    let halfGameWidth = this.backgroundContainer.displayData.width / 2;
    let halfGameHeight = this.backgroundContainer.displayData.height / 2;
    halfGameHeight -= data.isMobile ? 640 : 0;

    if (data.isLandscape) {
      this.slot.anchorDefault();
      this.slot.scale.set(this.slot.displayData.scaleX);
      this.decor.goToFrame(1);
      this.logo.goToFrame(1);
      this.frontBackgroundContainer.addChild(this.cookieMan);
      const mainPivotX = halfGameWidth + 300;
      const mainPivotY = halfGameHeight - 50;
      this.pivot.x = mainPivotX;
      this.pivot.y = mainPivotY;
      this.x = mainPivotX;
      this.y = mainPivotY;
    } else if (data.isMobile && data.isPortrait) {
      this.slot.pivot.x = this.slot.displayData.width / 2;
      this.slot.x = this.backgroundContainer.displayData.width / 2;
      this.slot.y = 152;
      this.slot.scale.set(1023 / this.slot.displayData.width);
      const mainPivotX = halfGameWidth + 100;
      const mainPivotY = halfGameHeight - 50;
      this.pivot.x = mainPivotX;
      this.pivot.y = mainPivotY;
      this.x = mainPivotX;
      this.y = mainPivotY;
      this.decor.goToFrame(2);
      this.logo.goToFrame(2);
      this.backgroundContainer.addChild(this.cookieMan);
    }
  }

  init() {
    this.displayData.x = this.x;
    this.displayData.y = this.y;
    this.winningsController = new BaseSlotWinningsController({ nextWinTimeout: 2000, nextScatterWinTimeout: 3333 });

    this.slot = this.getChildByName('SlotWrapper');
    this.reelsContainer = this.slot.getChildByName('reelsContainer');

    this.freespinsStart = this.getChildByName('freespinsStart');
    this.freespinsEnd = this.getChildByName('freespinsEnd');

    // this.linesContainer = this.slotContainer.getChildByName('LinesContainer');

    // this.nearWinContainer = this.slot_container.getChildByName('NearWinContainer');
    // this.lineWinningContainer = this.slot_container.getChildByName('LineWinningContainer');

    this.backgroundContainer = this.getChildByName('backgroundContainer');
    this.frontBackgroundContainer = this.getChildByName('backgroundFrontContainer');
    this.bonusUiContainer = this.getChildByName('bonusUiContainer');
    this.decor = this.getChildByName('decor');

    this.cookieMan = this.getChildByName('cookieMan');
    this.logo = this.getChildByName('logo');
    // this.bigWinContainer = this.getChildByName('BigWinContainer');
    // this.purchaseContainer = this.getChildByName('PurchaseContainer');
    //this.linesContainer.showLines(GameModel.lines);
  }

  addListeners() {
    GlobalDispatcher.add('model:linesChanged', this.onLinesChanged, this);
    GlobalDispatcher.add('stateManager.stateChanged', this.onStateChanged, this);
    GlobalDispatcher.add('stateEnd:initState', this.onInitStateEnd, this);
    GlobalDispatcher.add(eEventTypes.EET_FREESPINS_START__SHOWN_UP, this.showBonusUi, this);
    GlobalDispatcher.add(eEventTypes.EET_FREESPINS_END__SHOWN_UP, this.hideBonusUi, this);
    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this.onGameResized,
      this
    );
    GlobalDispatcher.add(eBaseEventTypes.EBET_ANTISIPATOR__START, this.onStartAntisipator, this);
    GlobalDispatcher.add(eBaseEventTypes.EBET_ANTISIPATOR__STOP, this.onStopAntisipator, this);

    // GlobalDispatcher.add('model:getServerData', this.checkForFreeSpins, this);
  }

  onStartAntisipator() {
    requestAnimationFrame(() => {
      gsap.to(this.scale, { x: 1.03, y: 1.03, duration: 2.5 });
    });
  } 

  onStopAntisipator() {
    gsap.to(this.scale, { x: 1, y: 1, duration: 0.2 })
  }

  showBonusUi() {
    this.bonusUiContainer.show();
  }

  hideBonusUi() {
    this.bonusUiContainer.hide();
  }

  onLinesChanged(data) {
    //this.linesContainer.showLines(data.params);
  }

  onInitStateEnd() {
    // if (!EntryPoint.GameModel.isFreeSpinsMode) return;
    // this.backgroundContainer.showFreeSpinsBack();
    // SoundManager.pause(sounds.BACKGROUND.name);
    // SoundManager.play(sounds.FREE_SPINS_BACK.name, sounds.FREE_SPINS_BACK.volume, true, 'music');
  }

  onStateChanged(data) {
    switch (data.params) {
      case eStateTypes.EST_INIT:
        break;
      case eStateTypes.EST_WAIT_USER_INTERACTION:
        this.showBonusUi();
        break;
      case eStateTypes.EST_IDLE:
        break;
      case eStateTypes.EST_FREE_SPINS_IN:
        this.freespinsStart.show(1000);
        this.winningsController.reset();
        break;
      case eStateTypes.EST_FREE_SPINS_OUT:
        this.freespinsEnd.show();
        this.winningsController.reset();
        break;
      case eStateTypes.EST_REQUEST_ROLLING:
        this.slot.start();
        this.winningsController.reset();
        break;
      case eStateTypes.EST_STOP_ROLLING:
        this.slot.stop();
        break;
      case eStateTypes.EST_SHOW_WIN:
        break;
      case eStateTypes.EST_SHOW_LINES_WIN:
        break;
      case eStateTypes.EST_SHOW_WINNINGS:
        this.winningsController.start();
        break;
    }
  }
}
